import { useEffect } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import TrustBar from "./components/TrustBar";
import TrustSection from "./components/TrustSection";
import FeaturedCategories from "./components/FeaturedCategories";
import CategoryGrid from "./components/CategoryGrid";
import Testimonials from "./components/Testimonials";
import ArticleCTA from "./components/ArticleCTA";
import SeoContent from "./components/SeoContent";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://kakobuyspreadsheet.art";
const logoUrl = "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/9f7209ca9e1d80750ccbea8c559f256f.png";

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Kakobuy Spreadsheet",
  "url": siteUrl,
  "description": "Największy arkusz produktów Kakobuy w Polsce. Ponad 10 000 sprawdzonych produktów, zdjęcia QC, przewodniki zakupowe i najlepsze oferty.",
  "inLanguage": "pl-PL"
};

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Kakobuy Sheet",
  "url": siteUrl,
  "logo": logoUrl,
  "sameAs": [
    "https://kaspreadsheet.com"
  ]
};

export default function Home() {
  useEffect(() => {
    const websiteScript = document.createElement("script");
    websiteScript.type = "application/ld+json";
    websiteScript.textContent = JSON.stringify(websiteSchema);
    document.head.appendChild(websiteScript);

    const orgScript = document.createElement("script");
    orgScript.type = "application/ld+json";
    orgScript.textContent = JSON.stringify(organizationSchema);
    document.head.appendChild(orgScript);

    return () => {
      if (websiteScript.parentNode) {
        websiteScript.parentNode.removeChild(websiteScript);
      }
      if (orgScript.parentNode) {
        orgScript.parentNode.removeChild(orgScript);
      }
    };
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <TrustBar />
        <TrustSection />
        <FeaturedCategories />
        <CategoryGrid />
        <SeoContent />
        <Testimonials />
        <ArticleCTA />
      </main>
      <Footer />
    </>
  );
}